import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import RemoveIcon from "@material-ui/icons/HighlightOff";
import CheckIcon from "@material-ui/icons/CheckCircleOutline";
import { connect } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
  Avatar,
  Box,
  Button,
  Card,
  Chip,
  Grid,
  IconButton,
  Paper,
  Typography,
} from "@material-ui/core";
import { Autocomplete, Timeline } from "@material-ui/lab";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import {
  AutocompleteValidator,
  DatePickerValidator,
} from "../../../../utilities/validators";
import AddAthlete from "../../../Athletes/components/PatientFormDialog/PatientFormDialog";
import { getPatientsWithoutParamsRequest } from "../../../Athletes/PatientApiActions";
import {
  addCaseRequest,
  getCasePrioritiesRequest,
  getCaseStatusForDoctorRequest,
  getCaseStatusRequest,
  getDoctorsOfDeptRequest,
  getSignedUrlRequest,
  uploadToS3Request,
} from "../../CasesApiAction";
import { getUserInfo } from "../../../../utilities/storage";
import NoteTimeline from "./components/NoteItem/NoteItem";
import { useStyles } from "./styles";
import NoteForm from "../NoteForm/NoteForm";
import defaultUser from "../../../../assets/user.png";

/**
 * function to render case form
 * @param history: history from router
 * @returns {JSX.Element}
 * @constructor
 */
const AddCase = ({
  history,
  selectedDept,
  getAllAthletes,
  athletes,
  getCasePriorities,
  casePriorities,
  getCaseStatusForDoctor,
  caseStatus,
  getDoctorsOfDept,
  doctors,
  addCase,
  getSignedUrl,
  uploadToS3,
}) => {
  const classes = useStyles();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const athleteID = Number(query.get("athleteID"));
  const [selectedAthlete, setSelectedAthlete] = useState(null);
  const [status, setStatus] = useState(null);
  const [injuryDate, setInjuryDate] = useState(null);
  const [onSetDate, setOnSetDate] = useState(null);
  const [firstSeenDate, setFirstSeenDate] = useState(null);
  const [description, setDescription] = useState("");
  const [caseUrgency, setCaseUrgency] = useState(null);
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [fixedDoctor, setFixedDoctor] = useState([]);
  const [showNoteBox, setShowNoteBox] = useState(false);
  const [openCreateAthleteModal, setOpenCreateAthleteModal] = useState(false);
  const [noteImages, setNoteImages] = useState([]);
  const [note, setNote] = useState("");
  const [noteItems, setNoteItems] = useState([]);
  const [showNoteErrorMessage, setShowNoteErrorMessage] = useState("");
  const [openMedicalUpload, setOpenMedicalUpload] = useState(false);

  useEffect(() => {
    if (athleteID) {
      const athlete =
        athletes &&
        athletes.rows &&
        athletes.rows.find((athlete) => athlete.id === athleteID);

      if (athlete) {
        setSelectedAthlete(athlete);
      }
    }
  }, [athleteID, athletes]);

  useEffect(() => {
    if (doctors) {
      const doctor = doctors.rows.filter(
        (doctor) => doctor.userId === getUserInfo().id
      );
      setFixedDoctor(doctor);
      setSelectedDoctors([...doctor]);
    }
  }, [doctors]);

  useEffect(() => {
    getAllAthletes(selectedDept.team_id, "team").then((res) => {});
  }, [getAllAthletes, selectedDept.team_id]);

  useEffect(() => {
    getCasePriorities().then((res) => {});
  }, [getCasePriorities]);

  useEffect(() => {
    getCaseStatusForDoctor().then((res) => {});
  }, [selectedDept]);

  useEffect(() => {
    getDoctorsOfDept(selectedDept.team_id).then((res) => {});
  }, [getDoctorsOfDept, selectedDept.team_id]);

  /**
   * function to handle closing of note form box
   */
  const handleNoteBoxClose = () => {
    setShowNoteBox(false);
    setNote("");
    setNoteImages([]);
    setShowNoteErrorMessage("");
  };

  /**
   * function to handle add note
   */
  const handleNotes = () => {
    if (noteImages.length === 0 && note.length === 0) {
      setShowNoteErrorMessage(
        "Please enter note or select image or medical image"
      );
    }

    if (note.length !== 0 || noteImages.length !== 0) {
      const data = {
        noteText: note,
        noteImages: noteImages,
        mediaUrls: [],
      };

      noteImages.forEach((image) => {
        const imageData = {
          fileName: image.file.name,
          fileType: `.${image.file.name.split(".").pop()}`,
        };

        getSignedUrl(imageData).then((res) => {
          uploadToS3(res.urls, image.file).then(() => {
            data.mediaUrls.push(res.path);
          });
        });
      });

      setNoteItems((noteItems) => [data, ...noteItems]);
      setShowNoteBox(false);
      setNoteImages([]);
      setNote("");
    }
  };

  /**
   * function to add case
   * @param e: event object
   */
  const onAdd = (e) => {
    e.preventDefault();

    const doctorIds = [];
    selectedDoctors.map((doctor) => doctorIds.push(doctor.userId));
    const logItems = [];
    noteItems.map((item) =>
      logItems.push({
        text: item.noteText,
        mediaUrls: item.mediaUrls,
        mediaId: item.mediaId,
      })
    );

    const data = {
      priority: caseUrgency.id,
      teamId: selectedDept.team_id,
      patientId: selectedAthlete.id,
      desc: description,
      status: status.id,
      date: moment(injuryDate).format("MM-DD-YYYY"),
      onSetDate: onSetDate ? moment(onSetDate).format("MM-DD-YYYY") : null,
      firstSeenDate: firstSeenDate
        ? moment(firstSeenDate).format("MM-DD-YYYY")
        : null,
      caregiver: doctorIds,
      logItem: logItems,
    };

    delete data["date"];

    addCase(data).then((res) => {
      history.push(`/cases/${res.id}`);
    });
  };

  /**
   * function to render doctor chip
   * @param props: doctor details
   * @returns {JSX.Element}
   * @constructor
   */
  const DoctorChip = (props) => (
    <Chip avatar={<Avatar alt="profile" src={props.url} />} {...props} />
  );

  const athleteOptions =
    athletes && athletes.rows ? [...athletes.rows, { id: -1 }] : [{ id: -1 }];

  /**
   * function to handle athlete selection
   * @param e
   * @param value
   */
  const handlePatientSelection = (e, value) => {
    if (value && value.id === -1) {
      setOpenCreateAthleteModal(true);
    } else {
      setSelectedAthlete(value);
    }
  };

  return (
    <>
      <ValidatorForm onSubmit={onAdd}>
        <Box>
          <Box className={classes.container}>
            <Box>
              <Box className={classes.titleContainer}>
                <Typography className={classes.title}>Create Case</Typography>
              </Box>

              <Box>
                <Box component={Paper} p={3} m={2}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <AutocompleteValidator
                        disabled={!!athleteID}
                        fullWidth
                        size="small"
                        options={athleteOptions}
                        value={selectedAthlete}
                        onChange={handlePatientSelection}
                        getOptionSelected={(option, value) =>
                          option.id === value.id
                        }
                        getOptionLabel={(option) => {
                          if (option.id !== -1) {
                            return `${option.firstName} ${option.lastName} ${
                              option.mrn && `, #${option.mrn}`
                            } `;
                          } else {
                            return "";
                          }
                        }}
                        renderOption={(option) => {
                          if (option.id !== -1) {
                            return (
                              <Box className={classes.optionsContainer}>
                                <Box className={classes.optionAvatar}>
                                  <img
                                    alt="profile"
                                    src={
                                      option.imageUrl
                                        ? option.imageUrl
                                        : defaultUser
                                    }
                                    className={classes.optionAvatarImage}
                                  />
                                </Box>
                                <Box className={classes.optionNameContainer}>
                                  {option.firstName} ${option.lastName}
                                </Box>
                              </Box>
                            );
                          } else {
                            return (
                              <Box className={classes.addOption}>
                                Add Patient
                              </Box>
                            );
                          }
                        }}
                        renderInput={(params) => (
                          <TextValidator
                            {...params}
                            label="Patient *"
                            variant="outlined"
                          />
                        )}
                        validators={["required"]}
                        errorMessages={["Patient is required"]}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <AutocompleteValidator
                        fullWidth
                        size="small"
                        options={caseStatus}
                        getOptionSelected={(option, value) =>
                          option.id === value.id
                        }
                        getOptionLabel={(option) => {
                          return (
                            option.description.charAt(0).toUpperCase() +
                            option.description.slice(1)
                          );
                        }}
                        renderInput={(params) => (
                          <TextValidator
                            {...params}
                            label="Status *"
                            variant="outlined"
                          />
                        )}
                        value={status}
                        onChange={(e, value) => setStatus(value)}
                        validators={["required"]}
                        errorMessages={["Status is required"]}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePickerValidator
                          fullWidth
                          label="Onset Date"
                          inputVariant="outlined"
                          size="small"
                          format="MM/dd/yyyy"
                          maxDate={new Date()}
                          value={onSetDate}
                          onChange={(date) => setOnSetDate(date)}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePickerValidator
                          fullWidth
                          label="First Seen Date"
                          inputVariant="outlined"
                          size="small"
                          format="MM/dd/yyyy"
                          maxDate={new Date()}
                          value={firstSeenDate}
                          onChange={(date) => setFirstSeenDate(date)}
                        />
                      </MuiPickersUtilsProvider>
                    </Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <AutocompleteValidator
                        fullWidth
                        size="small"
                        options={casePriorities}
                        getOptionSelected={(option, value) =>
                          option.id === value.id
                        }
                        getOptionLabel={(option) => {
                          return (
                            option.description.charAt(0).toUpperCase() +
                            option.description.slice(1)
                          );
                        }}
                        renderInput={(params) => (
                          <TextValidator
                            {...params}
                            label="Urgency *"
                            variant="outlined"
                          />
                        )}
                        value={caseUrgency}
                        onChange={(e, value) => setCaseUrgency(value)}
                        validators={["required"]}
                        errorMessages={["Case urgency is required"]}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Autocomplete
                        fullWidth
                        size="small"
                        multiple
                        options={
                          doctors && doctors.rows
                            ? doctors.rows.filter(
                                (item) => item.role === "Doctor"
                              )
                            : []
                        }
                        value={selectedDoctors}
                        filterSelectedOptions
                        onChange={(e, value) => {
                          setSelectedDoctors([
                            ...fixedDoctor,
                            ...value.filter(
                              (option) => fixedDoctor.indexOf(option) === -1
                            ),
                          ]);
                        }}
                        getOptionLabel={(option) => {
                          return option.firstName + " " + option.lastName;
                        }}
                        getOptionSelected={(option, value) =>
                          option.userId === value.userId
                        }
                        renderOption={(option) => (
                          <Box className={classes.optionsContainer}>
                            <Box className={classes.optionAvatar}>
                              <Avatar alt="profile" src={option.imageUrl} />
                            </Box>
                            <Box
                              className={classes.optionNameContainer}
                            >{`${option.firstName} ${option.lastName} `}</Box>
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextValidator
                            {...params}
                            label="Doctors"
                            variant="outlined"
                          />
                        )}
                        renderTags={(tagValue, getTagProps) => {
                          return tagValue.map((option, index) => (
                            <DoctorChip
                              key={index}
                              {...getTagProps({ index })}
                              label={`${option.firstName} ${option.lastName}`}
                              url={option.imageUrl}
                              color={
                                option.userId === getUserInfo().id
                                  ? "primary"
                                  : ""
                              }
                              deleteIcon={
                                option.userId === getUserInfo().id ? (
                                  <CheckIcon />
                                ) : (
                                  <RemoveIcon />
                                )
                              }
                            />
                          ));
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <TextValidator
                        fullWidth
                        label="Description *"
                        size="small"
                        variant="outlined"
                        multiline
                        rows={6}
                        rowsMax={6}
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        validators={["required"]}
                        errorMessages={["Description is required"]}
                      />
                    </Grid>
                  </Grid>
                </Box>

                <Box className={classes.addNoteHeadingContainer}>
                  <Box>
                    <Typography className={classes.addNoteLabel}>
                      Notes
                    </Typography>
                  </Box>

                  {!showNoteBox && (
                    <Box>
                      <IconButton
                        color="primary"
                        onClick={() => setShowNoteBox(true)}
                      >
                        <AddCircleIcon />
                      </IconButton>
                    </Box>
                  )}
                </Box>

                {showNoteBox && (
                  <Box component={Paper} p={3} m={2}>
                    <NoteForm
                      handleNoteBoxClose={handleNoteBoxClose}
                      note={note}
                      setNote={setNote}
                      noteImages={noteImages}
                      setNoteImages={setNoteImages}
                      handleNotes={handleNotes}
                      showNoteErrorMessage={showNoteErrorMessage}
                      setShowNoteErrorMessage={setShowNoteErrorMessage}
                      openMedicalUpload={openMedicalUpload}
                    />
                  </Box>
                )}

                <Box>
                  <Timeline>
                    {noteItems.map((note, index) => (
                      <NoteTimeline key={index} note={note} />
                    ))}
                  </Timeline>
                </Box>
              </Box>
            </Box>
          </Box>

          <Box className={classes.formBottomContainer}>
            <Box component={Card} raised className={classes.buttonsContainer}>
              <Box>
                <Button
                  variant="outlined"
                  color="primary"
                  disableElevation={true}
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  Cancel
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  disableElevation={true}
                  type="submit"
                  classes={{ root: classes.savebutton }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </ValidatorForm>

      <Box>
        <AddAthlete
          openCreateAthleteModal={openCreateAthleteModal}
          setOpenCreateAthleteModal={setOpenCreateAthleteModal}
          setSelectedAthlete={setSelectedAthlete}
        />
      </Box>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    athletes: state.athletes.athletes,
    casePriorities: state.cases.casePriorities,
    caseStatus: state.cases.caseStatus,
    doctors: state.cases.doctors,
    selectedDept: state.ayucareUsers.selectedDept,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addCase: (data) => {
      return dispatch(addCaseRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getAllAthletes: (id, type) => {
      return dispatch(getPatientsWithoutParamsRequest(id, type)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getCasePriorities: (data) => {
      return dispatch(getCasePrioritiesRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getCaseStatus: (data) => {
      return dispatch(getCaseStatusRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getCaseStatusForDoctor: (data) => {
      return dispatch(getCaseStatusForDoctorRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getDoctorsOfDept: (id) => {
      return dispatch(getDoctorsOfDeptRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getSignedUrl: (data) => {
      return dispatch(getSignedUrlRequest(data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    uploadToS3: (url, file) => {
      return dispatch(uploadToS3Request(url, file)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddCase);
